import { render, staticRenderFns } from "./Haproxy.vue?vue&type=template&id=35569780&"
import script from "./Haproxy.vue?vue&type=script&lang=js&"
export * from "./Haproxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports